import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="keyboard-shortcuts"
export default class extends Controller {
  static targets = ["element"]

  runAction(event) {
    let key = event.key?.toLowerCase()
    let target = this.elementTargets.filter((target) => {
      let regExp = new RegExp(target.dataset.keyCriterion)
      return regExp.test(key)
    })[0]

    if (!target) return

    if ((event.params.action === 'focus' && 
        (document.activeElement?.tagName === 'INPUT' || document.activeElement?.tagName === 'TEXTAREA') &&
        document.activeElement !== target) || this._is_text_selected()
    ) return

    event.params.action === 'focus' && target.setSelectionRange(-1, -1)
    key === 'escape' && event.preventDefault() 
    target[event.params.action]()    
  }

  _is_text_selected() {
      let active = document.activeElement
      if (active && (active.tagName === "INPUT" || active.tagName === "TEXTAREA")) {
        const start = active.selectionStart
        const end = active.selectionEnd
        return start != null && end != null && start !== end
      }
      return false
  }
}
